import { render, staticRenderFns } from "./UpdateCommentTicketDetail.vue?vue&type=template&id=3dd908f8&scoped=true"
import script from "./UpdateCommentTicketDetail.vue?vue&type=script&lang=js"
export * from "./UpdateCommentTicketDetail.vue?vue&type=script&lang=js"
import style0 from "./UpdateCommentTicketDetail.vue?vue&type=style&index=0&id=3dd908f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd908f8",
  null
  
)

export default component.exports